import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Select } from 'antd'
import { SelectValue } from 'antd/lib/select'
import { MapYear } from '../../services/map-municipalities.service'

const { Option } = Select

type Props = {
  handleYearSelection: (year: MapYear) => void,
  years: MapYear[]
  selectedYear?: MapYear
}

export const MapSelectYear: React.FC<Props> = ({
  handleYearSelection,
  selectedYear,
  years
}) => {

  const onChange = (value: SelectValue) => {
    const selectedYear = years.find(it => it.id === value)
    if (selectedYear) {
      handleYearSelection(selectedYear);
    }
  }

  return (
    <StyledSelect
      placeholder="Seleccione año"
      value={selectedYear?.name}
      onChange={onChange}
    >
      {years.map((y: MapYear) => (
        <Option key={y.id} value={y.id}>{y.name}</Option>
      ))}
    </StyledSelect>
  )
}

const StyledSelect = styled(Select)`
  width: 120px;
`
